<template>
    <div v-for="(measure, index) in measures" :key="measure.id">
        {{ measure.id }} | <strong>{{ measure.measured_at }}</strong> | {{ measure.value_key }} | {{ measure.value_unit_name }} ({{ measure.value_unit }}) | {{ measure.value_type }}
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    computed: mapState(['measures']),
    data() {
        return {
            //'elementUUID': this.getElementUUID()
        }
    },
    created() {
        /*axios.get('/api/v1/elements/' + this.elementUUID + '/measures')
            .then(response => {
                this.$store.commit('setMeasures', response.data.data);
            })
            .catch(error => {
                console.log("Error epale", error)
            })*/
    },
    methods: {
        format_date(value) {
            //TODO: DRY global?
            if (value) {
                return window.moment(String(value)).format('DD-MM-YYYY hh:mm:ss')
            }
        }
    }
}
</script>
